<template>
    <div class="mainpage">
        <div class="whitebox">
            <h1>Sign In</h1>
            <el-form :rules="rules" :model="account" ref="ruleForm" style="padding: 30px 0 0 0;font-size: 14px">

                <el-form-item prop="email" style="width: 100%;height: auto;">
                    <input placeholder="Email address" v-model.trim="account.email" type="email"
                           @keydown.enter="check">
                </el-form-item>

                <el-form-item prop="password" style="width: 100%;height: auto;">
                    <input placeholder="Password" type="password" v-model.trim="account.password"
                           @keydown.enter="check">
                </el-form-item>
                <p style="text-align: right;line-height: 25px;padding: 0px;cursor:pointer;">
                    <router-link to="/rest_password">Forgot password?</router-link>
                </p>

                <button type="button" @click="check">Continue</button>

            </el-form>

        </div><!--whitebox end--->
    </div><!--mainpage end--->
</template>
<script>
    import util from '../util';
    import config from '../config';

    let newTitle = 'Sign In - kinktest',
        newDescription = 'If you are a registered user, please log in with your email address and password.'
    export default {
        name: "signin",
        data() {
            return {
                account: {
                    email: '',
                    password: ''
                },
                doBack:null,
                rules: {
                    email: [{type: "email", message: 'Invalid format', trigger: 'blur'},
                        {required: true, message: 'Can\'t be empty', trigger: 'blur'}],
                    password: [{required: true, message: 'Can\'t be empty', trigger: 'blur'}]
                }
            }
        },
        mounted(){
            let oldTitle = document.head.querySelector('title').innerText
            document.head.querySelector('title').innerText = newTitle
            let meta = document.head.querySelector('meta[name="description"]')
            if(!meta){
                meta = document.head.appendChild(document.createElement('meta'))
                meta.setAttribute('name','description')
            }
            let oldMetaInfo = meta.getAttribute('content')
            meta.setAttribute('content',newDescription)
            let ogMeta = document.head.querySelector('meta[property="og:description"]')
            if(!ogMeta){
                ogMeta = document.head.appendChild(document.createElement('meta'))
                ogMeta.setAttribute('property','og:description')
            }
            let oldOgMetaInfo = ogMeta.getAttribute('content')
            ogMeta.setAttribute('content',newDescription)
            this.doBack = ()=>{
                document.head.querySelector('title').innerText = oldTitle
                meta.setAttribute('content',oldMetaInfo)
                ogMeta.setAttribute('content',oldOgMetaInfo)
            }
        },
        destroyed(){
            if(this.doBack)
                this.doBack()
        },
        methods: {
            check() {
                this.$refs.ruleForm.validate(v => {
                    if (v) {
                        util.axios.post(config.login_url, this.account).then(data => {
                            if (data && data.user) {
                                this.$store.commit('setUser', data);
                                this.goto();
                            }
                        })
                    }
                })
            },
            goto() {
                this.$router.push('/myaccount');
            }
        }
    }
</script>

<style scoped>

</style>
